/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Button } from '@components/atoms'
import { HomeSideNav, Footer } from '@components/systems'

import config from '@configs'
import { useNavigate } from 'react-router-dom'
import { HomeNavMenuType } from '@redux/index'
import { grey } from '@mui/material/colors'

const SupportPage = () => {
	// hook
	const navigate = useNavigate()

	const menuList: HomeNavMenuType[] = config.supportMenu()

	return (
		<View css={style}>
			<View className="outerView">
				<HomeSideNav menu={menuList} selectedIndes={-1} />

				<View className="contentOuterView">
					<Text category="h1">SUPPORT</Text>
					<View className="contentView">
						<View>
							<Button
								className="contentButton"
								variant="outlined"
								color="inherit"
								onClick={() => navigate('/manuals')}
							>
								User Manual
							</Button>
							<Button
								className="contentButton"
								variant="outlined"
								color="inherit"
								onClick={() => navigate('/privacy-policy')}
							>
								Privacy Policy
							</Button>
							<Button
								className="contentButton"
								variant="outlined"
								color="inherit"
								onClick={() => navigate('/store-policy')}
							>
								Store Policy
							</Button>
						</View>
						<View></View>
						<View></View>
					</View>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default SupportPage

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],

		'.sideMenuView': {
			width: '15rem',
			borderRight: '1px solid',
			borderColor: grey[300],

			'.sideMenuButton': {
				width: '100%',
				'.sideMenuTitle': {},
			},
		},

		'.contentOuterView': {
			width: 'calc(100% - 15rem)',
			minHeight: 'calc(100vh - 10rem)',
			padding: '2rem',
			borderLeft: '1px solid',
			borderColor: grey[300],

			'.contentView': {
				width: '100%',
				maxWidth: '50rem',
				right: 0,
				left: 0,
				margin: 'auto',
				paddingTop: '3rem',
				borderTop: '1px solid',
				borderColor: grey[500],

				'.contentButton': {
					width: '100%',
					marginBottom: '0.5rem',
				},
			},
		},
	},
})
